import { observable, computed, action, runInAction } from 'mobx'
import api from '../api'

class Auth {
  @observable user
  @observable loaded = false
  @observable resetRequested = false
  @observable resetSent = false

  @computed get loggedIn() {
    return !!this.user
  }

  @computed get activated() {
    return this.loggedIn && !this.user.license_pending
  }

  constructor() {
    this.load()
  }

  @action
  load() {
    return api.get('auth')
      .then(({data}) => {
        runInAction(() => {
          this.loaded = true
          this.user = data
        })
      }) 
      .catch(() => { this.loaded = true })
  }

  login(email, password) {
    return api.post('auth', { email, password }).then(
      ({data}) => { this.user = data }
    )
  }

  newInitialPassword(token) {
    return api.get('auth/initial_password', { params: { token } }).then(() => {})
  }

  setInitialPassword(token, password) {
    return api.post('auth/initial_password', { token, password }).then(
      ({data}) => { this.user = data }
    )
  }

  logout() {
    return api.delete('auth').then(
      () => { this.user = null }
    )
  }

  /**
   * Sends information to Draper's API which is forwarded to Ken to send password reset instructions
   * @param {string} email 
   */
  passwordResetRequest(email) {
    return api.post(`/users/passwords/reset?email=${email}`).then(
      () => { this.resetRequested = true}
    )
  }

  /**
   * Sends information to Draper's API which is forwarded to Ken to actually update the password
   * @param {string} reset_token
   * @param {string} password
   * @param {string} password_reset
   */
  passwordReset(reset_token, password, password_confirmation) {
    return api.put(`/users/passwords/reset/${reset_token}`, { password, password_confirmation }).then(
      () => { this.resetSent = true}
    )
  }
}

export default Auth



// WEBPACK FOOTER //
// client/stores/auth.js